import {
  BAG_SIZE_EXCEEDED,
  VARIANT_QUANTITY_EXCEEDED,
  VOUCHER_IN_THE_BAG,
  BRAND_QUANTITY_EXCEEDED,
  OUT_OF_STOCK,
  OUT_OF_ADDITIONAL_STOCK
} from "../../../../../services/bag/constants";
import {
  ITEM_TO_BAG_ERROR_BAG_SIZE_EXCEEDED,
  ITEM_TO_BAG_ERROR_OUT_OF_STOCK,
  ITEM_TO_BAG_ERROR_VOUCHER_IN_THE_BAG,
  ITEM_TO_BAG_ERROR_BRAND_QUANTITY_EXCEEDED
} from "../../constants";
import { findErrorsInMessages } from "./findErrorsInMessages";

const prioritisedMessages = [
  {
    errorCode: ITEM_TO_BAG_ERROR_VOUCHER_IN_THE_BAG,
    bagErrorCodes: [VOUCHER_IN_THE_BAG]
  },
  {
    errorCode: ITEM_TO_BAG_ERROR_OUT_OF_STOCK,
    bagErrorCodes: [OUT_OF_STOCK, OUT_OF_ADDITIONAL_STOCK]
  },
  {
    errorCode: ITEM_TO_BAG_ERROR_BAG_SIZE_EXCEEDED,
    bagErrorCodes: [BAG_SIZE_EXCEEDED, VARIANT_QUANTITY_EXCEEDED]
  },
  {
    errorCode: ITEM_TO_BAG_ERROR_BRAND_QUANTITY_EXCEEDED,
    bagErrorCodes: [BRAND_QUANTITY_EXCEEDED]
  }
];

export const getErrorCode = ({ message }) => {
  const messages = [].concat(message);
  const itemToBagError = prioritisedMessages.find(
    ({ bagErrorCodes }) =>
      findErrorsInMessages({ messages, bagErrorCodes }) !== null
  );

  return itemToBagError ? itemToBagError.errorCode : null;
};
